import { Component, OnInit } from '@angular/core';
import {Observable} from 'rxjs';
import {FormControl} from '@angular/forms';
import {startWith, map} from 'rxjs/operators'
@Component({
  selector: 'app-search-box',
  templateUrl: './search-box.component.html',
  styleUrls: ['./search-box-component.css']
})
export class SearchBoxComponent implements OnInit {

  public isActive: any;
  data: any[];
  dataset: any[];
  filteredStreets: Observable<string[]>;
  result: any[];
  control = new FormControl();
  key: string = undefined;
  constructor() {
  this.generateSamples();
  }
  ngOnInit() {
    this.filteredStreets = this.control.valueChanges.pipe(
        startWith(''),
        map(value => this._filter(value))
    );
  }

  private _filter(value : any): string[] {
    const filterValue = this._normalizeValue(value);
    return this.data.filter(street => this._normalizeValue(street).includes(filterValue));
  }

  private _normalizeValue(value : any): string {
    return value.toLowerCase().replace(/\s/g, '');
  }

  generateSamples(){
    // fill data
    this.dataset= [];
    let   NAMES = [
      "Redouan Eddafali",
      "Marla Vizcarra",
      "Emery Roussel",
      "Redouan Eddafali",
      "Jamar Boatright",
      "Reina Dobbins",
      "Redouan Eddafali",
      "Roselyn Pavon",
      "Henry Folkes",
      "Redouan Eddafali",
      "Redouan Eddafali",
      "Chauncey Quintero",
      "Redouan Eddafali",
      "Williemae Pasquale",
      "Redouan Eddafali",
      "Von Devries",
      "Redouan Eddafali",
      "Bethanie Bush",
      "Amalia Iliff"];
    let   ROOM_TYPES = [
      "Single",
      "Double",
      "Studio",
      "Sweet",
    ];
    let   AGE_TYPES = [
      "ADULT",
    ];
    let   GUEST_STATUS = [
      "check-in",
      "check-out",
      "in-house",
      "reserved",
    ];
    const randomYear = 2000 + Math.floor(Math.random() * 10);
    const randomMonth = Math.floor(Math.random() * 11);
    const randomDay = Math.floor((Math.random() * 28));
    for (let j=0 ; j<50;j++){
      this.dataset[j] = {
        id: 9000000 + Math.floor(Math.random() * 9000),
        guestName: NAMES[Math.floor(Math.random() * (NAMES.length))] ,
        class: AGE_TYPES[Math.floor(Math.random() * (AGE_TYPES.length))] ,
        roomtype: ROOM_TYPES[Math.floor(Math.random() * (ROOM_TYPES.length))],
        state: GUEST_STATUS[Math.floor(Math.random() * (GUEST_STATUS.length))],
        start: `${randomMonth}/${randomDay}/${randomYear}`,
        finish: `${randomMonth}/${randomDay}/${randomYear}`,
      };
    }
  }

  filter() {
    this.result =[];
    if (this.key == undefined || this.key=="") this.result =[];
    else this.result = this.dataset.filter(value =>{
     let id :String = value.id.toString();
     let name :String = value.guestName.toString();
     return id.includes(this.key) || !name.includes(this.key) ;
    });
  }
}

